<ng-template #docSectionHeader let-document="document">
  <div (click)="toggleDocumentSection(document.value, 'undefined')" [attr.id]="'toggle_'+ (document.value.docKey)"
    class="cursor-pointer dark-section d-flex justify-content-between align-items-center py-4 pl-4 pr-6"
    [class.dashed-border-bottom]="container === containerTypes.PANEL && docIsDisplayedMap[document.value.docKey]">
    <h6 [ngClass]="{'py-2 my-0': container === containerTypes.PANEL}">
      {{documentNamesMap[document.value.document_name]}}
    </h6>
    <span>
      <small class="fs-12 info-text"
        *ngIf="!docIsDisplayedMap[document.value.docKey] && document.value.signing_option !== onlyUpload">
        {{
        (document.value.selectedSignatories?.length ? document.value.selectedSignatories?.length : 'No')
        +
        (document.value.selectedSignatories?.length === 1 ? ' Signatory' : ' Signatories')
        }}
      </small>
      <small class="fs-12 cp-action-link align-text-bottom"
        *ngIf="!docIsDisplayedMap[document.value.docKey] && document.value.signing_option === onlyUpload">
        {{document.value.uploadedSignedDoc || document.value.document_url ? 'View' : 'No'}} Uploaded Doc
      </small>
      <small class="pl-6 fs-12 cp-action-link align-text-bottom"
        *ngIf="!docIsDisplayedMap[document.value.docKey] && document.value.signing_option !== onlyUpload">
        {{(document.value.selectedSignatories?.length ? 'View Signing Status' : '')}}
      </small>
      <i *ngIf="!docIsDisplayedMap[document.value.docKey]"
        class="pl-4 d-inline-block fa fa-eye fs-16 enabled-text"></i>
      <i *ngIf="docIsDisplayedMap[document.value.docKey]"
        class=" d-inline-block fa fa-eye-slash fs-16 enabled-text"></i>
    </span>
  </div>
</ng-template>

<form autocomplete="off" [formGroup]="signDocumentsForm">
  <div *ngIf="container === containerTypes.PANEL" class="d-flex justify-content-end mt-4 mb-5 px-4">
    <small (click)="toggleAllDocs()" id="toggle-all-document-sections" class="cp-action-link align-text-bottom">
      {{!allDocsShown ? 'Expand' : 'Collapse'}} All
      <i [ngClass]="{'fa-chevron-up': allDocsShown, 'fa-chevron-down': !allDocsShown}"
        class="pl-4 fa fs-16 warning-text"></i>
    </small> 
  </div>
  <div formArrayName="sign_documents" *ngFor="let document of signDocumentsForm.get('sign_documents')['controls']; 
    let docIndex = index; last as isLast;" [ngClass]="{'pt-2 pb-4 px-3': container === containerTypes.PANEL}">
    <div class="single-doc-section" [formGroupName]="docIndex">
      <ng-container *ngTemplateOutlet="docSectionHeader; context:{document: document}">
      </ng-container>
      <div [hidden]="!docIsDisplayedMap[document.value.docKey]" class="light-section py-6 px-4">
        <div class="mb-2 mx-2" *ngIf="document.value.document_name === 'deal_confirmation_note'">
          For Investor: {{document.value.investor_comp_name}}
        </div>
        <div class="mb-3 mx-2" *ngIf="document.value.document_name === 'promissory_note'">
          Please upload the scanned copy of physically signed promissory note
        </div>

        <!-- Select Signatories Section -->
        <ng-select [attr.companyId]="document.value.investor_id" [attr.id]="document.value.doc_signatory_html_id"
          [items]="modalInputs.signatoriesList" class="icici-custom" [multiple]="true" bindLabel="name"
          [hideSelected]="true" formControlName="selectedSignatories"
          *ngIf="document.value.signing_option === uploadOrEsign || document.value.signing_option === onlyEsign"
          placeholder="Search for Signatories ... ">
          <!--Template for selected label-->
          <ng-template ng-label-tmp let-signatory="item">
            <span class="ng-value-label">{{signatory.name}}
              <small *ngIf="signatory.group_name" class="info-text font-style-normal">
                ({{signatory.group_name}})</small>
            </span>
            <span aria-hidden="true" class="ng-value-icon right"
              (click)="removeDocSignatory(docIndex, signatory.id)">×</span>
          </ng-template>
          <!--Template for option in select dropdown-->
          <ng-template ng-option-tmp let-signatory="item">
            {{signatory.name}}
            <small *ngIf="signatory.group_name" class="info-text font-style-normal">
              ({{signatory.group_name}})</small>
          </ng-template>
        </ng-select>

        <!-- Signing Status Section -->
        <div class="light-bg mt-5 border rounded mx-auto w-50"
          *ngIf="(document.value.signing_option === uploadOrEsign || document.value.signing_option === onlyEsign) && document.value.selectedSignatories?.length">
          <!-- Header -->
          <div class="dark-bg rounded-top border-bottom pl-4 py-2">
            <small>
              Signing Status
            </small>
          </div>

          <div class="{{ isLast ? '' : 'border-bottom' }} px-3 py-1 d-flex align-items-center justify-content-between"
            *ngFor="let sig of document.value.selectedSignatories; let isLast = last; let sigIndex = index">
            <div id="signing-signatory-name-{{docIndex}}-{{sigIndex}}" class="flex-grow-1">
              {{ sig.name | titlecase }}
            </div>
            <i *ngIf="sig.signed" class="mr-3 small fa fa-check-circle cp-green-icon">
            </i>
            <i *ngIf="!sig.signed && sig.is_email_sent" class="mr-3 small fa fa-check-circle">
            </i>
            <div class="small font-italic" id="signing-status-{{docIndex}}-{{sigIndex}}">
              {{ sig.signed ? 'Signed' : (sig.is_email_sent ? 'Waiting for Sign' : 'New Signatory') }}
            </div>
          </div>
        </div>

        <div class="text-center my-2" *ngIf="document.value.signing_option === uploadOrEsign">Or</div>
        <div class="d-flex justify-content-between"
          *ngIf="document.value.signing_option === uploadOrEsign || document.value.signing_option === onlyUpload">
          <div class="flex-grow-1 text-center mx-2">
            <app-upload-button [attr.id]="document.value.doc_upload_html_id"
              [attr.companyId]="document.value.investor_id" [fileTypes]="fileTypes"
              [componentId]="'btn_'+document.value.doc_upload_html_id" #uploadComp
              (fileAsDataURL)="onUploadFileChange($event, document)"></app-upload-button>
          </div>
          <div class="flex-grow-0 mx-2">
            <small class="uploaded-doc-name">{{uploadComp.fileName || "None Uploaded"}}</small>
          </div>
          <div class="flex-grow-0 mx-2" *ngIf="document.value.document_url">
            <a class="external-link" (click)="showDocument(document.value.document_name, document.value.document_url)">
              <small>
                View Last Uploaded<i class="fa fa-external-link-square-alt ml-2"></i>
              </small>
            </a>
          </div>
        </div>
      </div>
      <hr *ngIf="container === containerTypes.MODAL && !isLast" />
    </div>
  </div>
</form>
<div class="modal-footer modal-footer-custom mt-6" [ngClass]="{'sidepanel-footer': container === containerTypes.PANEL}">
  <button type="button" class="col-md-4 btn btn-outline-success btn-style-right-1 text-left" id="sign-documents-cancel"
    (click)="cancelFormChanges()">Cancel</button>
  <button [attr.disabled]="signDocumentsForm.pristine? true : null"
    class="col-md-6 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
    id="sign-documents-submit" (click)='postSignedDocuments()'>
    {{modalInputs.isInitialSign ? 'Done' : 'Modify Signatories'}}
  </button>
</div>